import { createSelector } from 'reselect';
const getRootOrderState = (state) => state.newOrder;
export const getTravellers = createSelector(getRootOrderState, order => order.travellers);
